import { observer } from 'mobx-react-lite'
import { CommonOptInMethod } from 'pages/settings/pages/compliance/ui/CommonOptInMethod/CommonOptInMethod'
import { useTollFreeStepsContext } from 'pages/settings/pages/compliance/pages/tollFree/context/tollFreeStepsContext'
import { RegistrationErrorAlert } from 'pages/settings/pages/compliance/pages/tollFree/ui/RegistrationErrorAlert/RegistrationErrorAlert'

export const OptInMethod = observer(() => {
  const { optInMethodStore, stepsStore } = useTollFreeStepsContext()
  const { stepLoading } = stepsStore
  const { isNextDisabled, setOptInMethods, isOptInMethodActive, nextStepClick } = optInMethodStore

  return (
    <>
      <RegistrationErrorAlert />
      <CommonOptInMethod
        stepLoading={stepLoading}
        isNextDisabled={isNextDisabled}
        onNextClick={() => nextStepClick()}
        isOptInMethodActive={isOptInMethodActive}
        setOptInMethods={setOptInMethods}
      />
    </>
  )
})
